module.exports = __webpack_public_path__ + "static/media/ic_logo.d7a09adc.png";